import { configureStore } from "@reduxjs/toolkit";
import fetchDropdownsReducer from "../components/CareerCard/DropdownSlice";
import empDetailsReducer from "../components/CareerCard/CareerCardDetailsSlice";
import empOracleDetailsReducer from "../components/CareerCard/EmpOracleDetailsSlice";
import addCareerCardReducer from "../components/CareerCard/AddCareerCardSlice";
import addCareerCardOtherDetailsReducer from "../components/CareerCard/AddCareerCardOtherDetailsSlice";
import getHierarchyDetailsReducer from "../components/Reportees/GetHierarchyDetailsSlice";
import importFromExcelAPICallReducer from "../components/CareerCard/ImportFromExcelSlice";
import dashboardGraphsReducer from "../components/DashboardMain/getDashboardGraphsSlice";
import orgChartReducer from "../components/Reportees/OrgChartSlice";

export const store = configureStore({
  reducer: {
    fetchDropdowns: fetchDropdownsReducer,
    empDetails: empDetailsReducer,
    empOracleDetails: empOracleDetailsReducer,
    addCareerCard: addCareerCardReducer,
    addCareerCardOtherDetails: addCareerCardOtherDetailsReducer,
    getHierarchyDetails: getHierarchyDetailsReducer,
    importFromExcelAPICall: importFromExcelAPICallReducer,
    dashboardGraphs: dashboardGraphsReducer,
    orgChart: orgChartReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
